import { render, staticRenderFns } from "./LogoAlertaHidrica.vue?vue&type=template&id=6c616503&scoped=true"
import script from "./LogoAlertaHidrica.vue?vue&type=script&lang=ts"
export * from "./LogoAlertaHidrica.vue?vue&type=script&lang=ts"
import style0 from "./LogoAlertaHidrica.vue?vue&type=style&index=0&id=6c616503&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c616503",
  null
  
)

export default component.exports